import { Navigate } from 'react-router-dom';
import { CustomerSingleTabGuard } from './customer-single-tab-guard';
import { accountService } from '../../_services/accounts.service';

export function AuthRoute(params: {
    element: JSX.Element
}): JSX.Element {

    const currentUser = accountService.currentUserValue;

    if (!currentUser || !currentUser.token || !currentUser.roles || !currentUser.roles.length) {
        return <Navigate to="/login" replace />;
    }

    return (
        <CustomerSingleTabGuard>
            {params.element}
        </CustomerSingleTabGuard>
    );
};

export default AuthRoute;